import { Injectable } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  tagsForSnits = 'Barge, barging, inland tanker, floating storage, Rhine, chemical tanker, Rhine transportation, stainless steel tanks, parcel tankers in Europe,storage tankers in Europe';
  constructor(private title: Title, private meta: Meta) { }

  updateTitle(title: string){
    this.title.setTitle(title);
  }
  updateMetaTags(metaTags: MetaDefinition[]){
    metaTags.forEach(m=> this.meta.updateTag(m));
  }
  
  addTags(metaTags: MetaDefinition[]){
    this.meta.addTags(metaTags);
    console.log("add done");
  }

  removeTags(){
    this.meta.removeTag("name='keywords'");
    this.meta.removeTag("name='description'");
  }
  
}
